import * as THREE from 'three';
import { GLTFLoader } from 'three/addons/loaders/GLTFLoader';
import { DRACOLoader } from 'three/examples/jsm/loaders/DRACOLoader';


import Store from '../Store';


class Model {
  constructor({ id, file, type, position, rotation, scale, showOnStep }) {
    this.id = id;
    this.file = file;
    this.type = type; // 'type' isn't being used in the original, but keeping it for consistency
    this.loader = new GLTFLoader(); 
    this.position = position;
    this.rotation = rotation;
    this.scale = scale;


    const dracoLoader = new DRACOLoader();
    dracoLoader.setDecoderPath('https://static.mused.org/spaceshare/draco1.5.6/'); // Adjust this path to where your Draco scripts are located

    // Attach DracoLoader instance to GLTFLoader
    this.loader.setDRACOLoader(dracoLoader);


    this.mesh = null;

    this.loader.load(this.file, this.handleLoad.bind(this));
  }

  handleLoad(gltf) {
    const { scene } = Store.getState();

    this.mesh = gltf.scene;
    this.mesh.name = this.id;

    // Destructure arrays to individual variables
    const [px, py, pz] = this.position;
    const [rx, ry, rz] = this.rotation;
    const [sx, sy, sz] = this.scale;

    // Set position, rotation, and scale here
    this.mesh.position.set(px, py, pz);
    this.mesh.rotation.set(rx, ry, rz);
    this.mesh.scale.set(sx, sy, sz); 
    this.mesh.visible = false;

    // handle custom matierals
    if (this.id === "horemheb-reconstruction") {
      const customMaterial = new THREE.MeshBasicMaterial({
        color: 0x69665d,
        transparent: true,
        opacity: 0.5,
      });

      this.setCustomMaterial(customMaterial);
    }

    scene.add(this.mesh);
  }

  setPosition(x, y, z) {
    if (!this.mesh) {
      console.warn('Model not loaded yet.');
      return;
    }

    this.mesh.position.set(x, y, z);
  }

  setRotation(x, y, z) {
      if (!this.mesh) {
          console.warn('Model not loaded yet.');
          return;
      }

      this.mesh.rotation.set(x, y, z);
  }

  setScale(x, y, z) {
      if (!this.mesh) {
          console.warn('Model not loaded yet.');
          return;
      }

      this.mesh.scale.set(x, y, z);
  }

  // Show the model
  show() {
      if (!this.mesh) {
          console.warn('Model not loaded yet.');
          return;
      }
      this.mesh.visible = true;
  }

  // Hide the model
  hide() {
      if (!this.mesh) {
          console.warn('Model not loaded yet.');
          return;
      }
      this.mesh.visible = false;
  }

  // Toggle visibility of the model
  toggleVisibility() {
      if (!this.mesh) {
          console.warn('Model not loaded yet.');
          return;
      }
      this.mesh.visible = !this.mesh.visible;
  }

  setCustomMaterial(material) {
    if (!this.mesh) {
      console.warn('Model not loaded yet.');
      return;
    }

    this.mesh.traverse((child) => {
      if (child instanceof THREE.Mesh) {
        child.material = material;
      }
    });
  }
}

export default Model;
